{
  "version": 1,
  "asset_id": "d39d0765-5590-48ea-a9e6-8f61d7ec38fe",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d39d0765-5590-48ea-a9e6-8f61d7ec38fe/sleeve-hiatal-type-1-second-en-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d39d0765-5590-48ea-a9e6-8f61d7ec38fe/sleeve-hiatal-type-1-second-en-800.jpg",
  "original_filename": "sleeve-hiatal-type-1-second-en-800.jpg",
  "size": 93512,
  "content_type": "image/jpeg",
  "created_at": "2026-09-26T22:31:55Z"
}
